import React, { useState } from 'react';
import { Column } from '../../../../hooks/useTablePages';
import { Input } from '../../../../components/Form';
import { gql, useMutation } from '@apollo/client';
import useNotify from '../../../../hooks/useNotify';
import { AddressType } from '../../../../components/Address/AddressPicker';
import { MakeItem } from './Makes.query';

const UPDATE_MAKE = gql`
  mutation UpdateMake($makeId: ID!, $input: BackflowAssemblyMakeInput!) {
    updateBackflowAssemblyMake(makeId: $makeId, input: $input) {
      id
      name
    }
  }
`;

const EditName: React.FC<EditNameProps> = ({ make }) => {
  const [name, setName] = useState(make.name);
  const { showError, showSuccess } = useNotify();

  const [updateMake] = useMutation<{
    createAddress: AddressType;
  }>(UPDATE_MAKE, {
    onCompleted: () => {
      showSuccess('Make updated');
    },
    onError: (error) => {
      showError('Error updating make', error);
    },
  });

  return (
    <Input
      sx={{
        font: 'inherit',
        height: 24,
        background: 'none',
        border: 'none',
        ':focus': {
          background: 'white',
        },
      }}
      onChange={(e) => setName(e.target.value)}
      onKeyPress={(e) => {
        const target = e.currentTarget;
        if (e.key === 'Enter') {
          target.blur();
        }
      }}
      onBlur={() => {
        if (name === make.name) {
          return;
        }
        updateMake({
          variables: {
            makeId: make.id,
            input: {
              name,
              visible: make.visible,
            },
          },
        });
      }}
      defaultValue={name}
      autoComplete="off"
    />
  );
};

type EditNameProps = {
  make: MakeItem;
};

const columns: Column[] = [
  {
    header: 'Id',
    accessor: 'id',
    width: 70,
  },
  {
    header: 'Name',
    id: 'name',
    accessor: (row: MakeItem) => {
      return <EditName key={row.id} make={row} />;
    },
    stringAccessor: (row: MakeItem) => {
      return row.name;
    },
    width: 200,
  },
  // {
  //  header: 'Visible',
  //   accessor: 'visible',
  //   width: 120,
  // },
];

export default columns;
